import { Briefcase, Building2, FileMinus, FileText, UserCircle } from 'lucide-react';
import { cn } from '@/lib/utils';
import type { FlatResult } from './search-dialog-types';

/**
 * Kleine, rein präsentative Bausteine für `search-dialog.tsx` — ausgelagert,
 * damit die Haupt-Datei unter der BL-112-300-Zeilen-Schranke bleibt (BL-115
 * brachte mit Gutschriften eine weitere Treffer-Art dazu).
 */

export function SectionLabel({ children }: { children: React.ReactNode }) {
  return (
    <div className="border-t border-hair bg-bg-alt px-4 py-1 text-xs font-medium uppercase tracking-wider text-muted-foreground first:border-t-0">
      {children}
    </div>
  );
}

export function ResultRow({
  item,
  active,
  onClick,
  onHover,
}: {
  item: FlatResult;
  active: boolean;
  onClick: () => void;
  onHover: () => void;
}) {
  const icons = {
    customer: Building2,
    project: Briefcase,
    consultant: UserCircle,
    invoice: FileText,
    gutschrift: FileMinus,
  };
  const Icon = icons[item.kind];
  return (
    <button
      type="button"
      onClick={onClick}
      onMouseEnter={onHover}
      className={cn(
        'flex w-full items-center gap-3 px-4 py-2 text-left text-sm transition-colors',
        active && 'bg-primary/10',
      )}
    >
      <Icon className="h-4 w-4 shrink-0 text-muted-foreground" />
      <div className="min-w-0 flex-1">
        <div className="truncate font-medium">{item.primary}</div>
        <div className="truncate text-xs text-muted-foreground">{item.secondary}</div>
      </div>
      {item.meta && (
        <div className="shrink-0 font-mono text-xs text-muted-foreground">{item.meta}</div>
      )}
    </button>
  );
}

export function Hint({
  icon: Icon,
  label,
}: {
  icon: React.ComponentType<{ className?: string }>;
  label: string;
}) {
  return (
    <span className="inline-flex items-center gap-1 rounded border px-2 py-0.5">
      <Icon className="h-3 w-3" />
      {label}
    </span>
  );
}

export function Kbd({ children }: { children: React.ReactNode }) {
  return <kbd className="rounded border bg-panel px-1 py-0.5 text-[10px]">{children}</kbd>;
}
